import { render } from "./SwitchActuator.vue?vue&type=template&id=628c7a94&ts=true"
import script from "./SwitchActuator.vue?vue&type=script&lang=ts"
export * from "./SwitchActuator.vue?vue&type=script&lang=ts"

import exportComponent from "/data/jenkins/workspace/PROD/SwissApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__